module.exports = __webpack_public_path__ + "img/d_1.68d3e9b9.png";